import React from 'react';
import { animated, useSpring } from 'react-spring';
import './SidebarMenu.css';
import Separator from './Separator';

function SidebarMenu({ isOpen, onClose, menuItems, onTopicChange }) {
    const sidebarAnimation = useSpring({
        transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
        opacity: isOpen ? 1 : 0,
        config: { mass: 1, tension: 280, friction: 25 },
    });

    const handleItemClick = (id) => {
        onTopicChange(id);
        onClose();
    };

    return (
        <>
            {isOpen && (
                <animated.div
                    className="sidebar-overlay"
                    onClick={onClose}
                    style={{ opacity: sidebarAnimation.opacity.to(o => o) }}
                />
            )}

            <animated.div
                className="sidebar-menu-wrapper"
                style={{
                    ...sidebarAnimation,
                    display: sidebarAnimation.opacity.to(o => o === 0 && !isOpen ? 'none' : 'block')
                }}
            >
                <div className="sidebar-header">
                    <h3>Topics</h3>
                    <button onClick={onClose} className="sidebar-close-button">×</button>
                </div>
                <ul className="sidebar-menu">
                    {menuItems.map((item, index) => (
                        <React.Fragment key={item.id || index}>
                            {item.separator ? (
                                <Separator /> // Render separator if the item is a separator
                            ) : (
                                <li onClick={() => handleItemClick(item.id)}>
                                    <a href="#">{item.title}</a>
                                </li>
                            )}
                        </React.Fragment>
                    ))}
                </ul>
            </animated.div>
        </>
    );
}

export default SidebarMenu;
